const SubsidiaryReadOnlyRow = ({t, subsidiary, handleDeleteClick, oddIdx}) => {
	return(
		<tr>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{subsidiary.companyName}</td>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{subsidiary.companyTypeDesc}</td>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{subsidiary.address}</td>
            <td className={oddIdx?"list-td col odd": "list-td col even"}>{subsidiary.phone}</td>
            <td className={oddIdx?"list-td col odd": "list-td col even"}>{subsidiary.status}</td>
            <td className={oddIdx?"list-td col col-md-auto odd": "list-td col col-md-auto even"}> 
            <button className="btn btn-primary btn-block" onClick={(event) => handleDeleteClick(event, subsidiary.companyId, subsidiary.statusCode)}>{subsidiary.statusCode === 1? t("page.delete") : t("page.undelete")}</button></td>
         </tr>
	)
}
export default SubsidiaryReadOnlyRow;